import { useEffect, useRef } from "react"

export const BELOW_FILTER_BAR = "top-[var(--filter-bar-height)]"

export function FilterBar({
  children,
  strip,
}: {
  children: React.ReactNode
  strip?: React.ReactNode
}): React.ReactElement {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const bar = ref.current
    const scroller = bar?.parentElement
    if (!bar || !scroller) return
    const observer = new ResizeObserver(() =>
      scroller.style.setProperty(
        "--filter-bar-height",
        `${bar.offsetHeight}px`,
      ),
    )
    observer.observe(bar)
    return () => {
      observer.disconnect()
      scroller.style.removeProperty("--filter-bar-height")
    }
  }, [])

  return (
    <div ref={ref} className="sticky top-0 z-20 bg-background">
      <div className="border-b px-3 py-1">{children}</div>
      {strip}
    </div>
  )
}
